const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20movie%20production%20with%20director%20chair%20and%20camera%20crew%20on%20film%20set%2C%20warm%20studio%20lighting%2C%20professional%20cinematography%20equipment%2C%20director%20monitor%20showing%20scene%2C%20creative%20atmosphere%2C%20film%20production%20documentary%20style%2C%20cinematic%20behind%20the%20scenes%20aesthetic&width=700&height=420&seq=media-behind-01&orientation=landscape',
    title: '探秘《奥本海默》实景拍摄幕后',
    duration: '15:28',
    views: '12.8万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Film%20director%20interview%20scene%20in%20a%20cozy%20studio%20with%20warm%20lighting%2C%20bookshelves%20and%20movie%20posters%20in%20background%2C%20two%20people%20sitting%20on%20chairs%20having%20conversation%2C%20professional%20but%20casual%20atmosphere%2C%20film%20industry%20talk%20show%20aesthetic%2C%20soft%20dramatic%20cinematic%20lighting&width=700&height=420&seq=media-interview-02&orientation=landscape',
    title: '诺兰谈《星际穿越》创作理念',
    duration: '22:10',
    views: '8.5万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Movie%20review%20and%20analysis%20scene%20with%20film%20stills%20displayed%20on%20multiple%20screens%2C%20modern%20editing%20studio%20with%20warm%20ambient%20lighting%2C%20film%20critic%20setup%20with%20notes%20and%20reference%20materials%2C%20intellectual%20and%20artistic%20atmosphere%2C%20cinematic%20color%20grading%20comparison%20display&width=700&height=420&seq=media-review-03&orientation=landscape',
    title: '2026 上半年必看高分电影盘点',
    duration: '18:45',
    views: '15.2万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading text-center">
          影视花絮
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          幕后故事、导演访谈与精彩影评
        </p>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item, i) => (
            <article
              key={i}
              className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden group cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:scale-110 transition-all">
                    <i className="ri-play-fill text-xl text-foreground-900 group-hover:text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-foreground-900/70 text-background-50 text-xs font-medium">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 font-heading line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {item.views} 次观看
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}